var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dg-error-component"},[_c('DgPanel',[_c('div',{staticClass:"dg-error-component__message"},[_vm._v(" "+_vm._s(_vm.finalMessage)+" ")]),_c('div',{staticClass:"text-center"},[_c('DgButton',{on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.btnTitle)+" ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }